const MADRID_TZ = 'Europe/Madrid';
const HAS_TZ = /[Zz]|[+-]\d{2}:\d{2}$/;

export function formatPublicationDate(value) {
  if (!value) {
    return '';
  }

  if (typeof value === 'string' && !HAS_TZ.test(value)) {
    const datePart = value.split('T')[0];
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
    if (match) {
      const [, year, month, day] = match;
      return `${Number(day)}/${Number(month)}/${year}`;
    }
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('ca-ES', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    timeZone: MADRID_TZ,
  }).format(date);
}
